<div class="d-flex flex-column gap-4">

    <!-- Ordered Assets -->

    <div *ngIf="orderedAssets.length > 0" class="d-flex flex-column gap-1">
        <span class="list-section-title">{{ 'asset.orderedAssets' | translate }}</span>
        <div class="list-section-divider"></div>
    </div>

    <div *ngIf="orderedAssets && orderedAssets.length > 0" class="cards-container mt-4">
        <div class="asset-card ccc ccc-hover"
            *ngFor="let asset of orderedAssets"
            (click)="navigateToDetailHandler(asset.assetId)"
            role="button">
            <div class="number">
                <dynamic-field [props]="props?.AssetName" [canBeEmpty]="true"
                    class="d-flex flex-wrap justify-content-center gap-2"
                >
                    <span HJSuppress class="manufacturer fw-bold">{{asset?.assetName}}</span>
                </dynamic-field>
            </div>
            <div class="asset-details">
                <dynamic-field [props]="props?.Description" [canBeEmpty]="true">
                    <span HJSuppress>
                        {{asset?.description}}
                    </span>
                </dynamic-field>
            </div>
            <div class="asset-details">
                <dynamic-field [props]="props?.Vin" [canBeEmpty]="true">
                    {{'asset.VIN' | translate}}:
                    <span HJSuppress>
                        {{asset?.vin}}
                    </span>
                </dynamic-field>
            </div>
            <div class="asset-details">
                <dynamic-field [props]="props?.Contract" [canBeEmpty]="true"
                    class="d-flex flex-wrap align-items-center justify-content-center gap-1"
                >
                    {{'asset.Contract' | translate}}:
                    <span HJSuppress class="contract text-primary fw-bold">
                        {{asset?.contract}}
                    </span>
                </dynamic-field>
            </div>
            <div class="asset-value mt-4 mb-3" *ngIf="asset.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING">
                <dynamic-field [props]="props?.Value" [canBeEmpty]="true" class="value-label">
                    {{'asset.Value' | translate}}
                    <span HJSuppress class="value">
                        {{asset?.value | number:'1.2-2'}} {{asset?.currency}}
                    </span>
                </dynamic-field>
            </div>

            <div class="d-flex flex-column mt-5">
                <div class="asset-details">
                    <div class="text-container">
                        <div class="condition">{{'asset.deliveryLocation' | translate}}:</div>
                        <div HJSuppress class="condition-value">
                            <div>{{asset?.deliveryLocation | replaceIfNull}}</div>
                        </div>
                    </div>
                    <hr class="divider">
                </div>
                <div class="asset-details">
                    <div class="text-container">
                        <div class="condition">{{'asset.clientDelegate' | translate}}:</div>
                        <div *ngIf="asset.deliveryDelegateName" HJSuppress class="condition-value">
                            {{asset?.deliveryDelegateName}}
                            <span class="link-underline-primary-custom" (click)="openDelegateModal($event, asset)">
                                {{'contractDetail.assets.change' | translate}}
                            </span>
                        </div>
                        <div *ngIf="!asset.deliveryDelegateName">
                            <div HJSuppress class="link-underline-primary-custom" (click)="openDelegateModal($event, asset)">
                                {{'contractDetail.assets.addDelegate' | translate}}
                            </div>
                        </div>
                    </div>
                    <hr class="divider">
                </div>

                <div class="align-self-center mt-3">
                    <div class="badge badge-delivery-state state-estimated d-flex align-items-center gap-1">
                        <div class="circle-box">
                            <div class="circle-box-inner"></div>
                        </div>
                        {{'contractDetail.assets.deliveryStatus.' + asset.deliveryStatus | translate}}:
                        {{ asset.deliveryDate ? (asset.deliveryDate | localizedDate) : '' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- All Assets -->

    <div *ngIf="orderedAssets.length > 0" class="d-flex flex-column gap-1">
        <span class="list-section-title">{{ 'asset.allAssets' | translate }}</span>
        <div class="list-section-divider"></div>
    </div>

    <div class="cards-container mt-4">
        <div class="asset-card ccc ccc-hover" *ngFor="let asset of assets"
            [ngClass]="{ 'inspection-style': asset.deliveryStatus === AssetDeliveryStatus.DELIVERED && asset.nextInspectionDate, 'ccc-hover': asset.deliveryStatus }"
            (click)="asset.deliveryStatus && navigateToDetailHandler(asset.assetId)"
            [attr.role]="asset.deliveryStatus? 'button' : null">
            <div class="number">
                <dynamic-field [props]="props?.AssetName" [canBeEmpty]="true"
                    class="d-flex flex-wrap justify-content-center gap-2"
                >
                    <span HJSuppress class="manufacturer fw-bold">{{asset?.assetName}}</span>
                </dynamic-field>
            </div>
            <div class="asset-details">
                <dynamic-field [props]="props?.Description" [canBeEmpty]="true">
                    <span HJSuppress>
                        {{asset?.description}}
                    </span>
                </dynamic-field>
            </div>
            <div class="asset-details">
                <dynamic-field [props]="props?.Vin" [canBeEmpty]="true">
                    {{'asset.VIN' | translate}}:
                    <span HJSuppress>
                        {{asset?.vin}}
                    </span>
                </dynamic-field>
            </div>
            <div *ngIf="asset?.registrationNumber" class="asset-details">
                <dynamic-field [props]="props?.RegistrationNumber" [canBeEmpty]="true">
                    {{'asset.RegistrationNumber' | translate}}:
                    <span HJSuppress>
                        {{asset?.registrationNumber}}
                    </span>
                </dynamic-field>
            </div>

            <div>
                <div class="asset-value">
                    <dynamic-field [props]="props?.Contract" [canBeEmpty]="true"
                        class="value-label d-flex flex-wrap align-items-center justify-content-center gap-1"
                    >
                        <span class="fs-14px">{{'asset.Contract' | translate}}:</span>
                        <span HJSuppress class="contract text-primary fw-bold">
                            {{asset?.contract}}
                        </span>
                    </dynamic-field>
                </div>
                <div class="asset-value mt-4 mb-3" *ngIf="asset.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING">
                    <dynamic-field [props]="props?.Value" [canBeEmpty]="true" class="value-label">
                        {{'asset.Value' | translate}}
                        <span HJSuppress class="value">
                            {{asset?.value | number:'1.2-2'}} {{asset?.currency}}
                        </span>
                    </dynamic-field>
                </div>
                <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED && asset.deliveryDate" class="asset-details">
                    <div class="text-container">
                        <div class="condition">{{'asset.deliveryDate' | translate}}:</div>
                        <div HJSuppress class="condition-value">
                            <div>{{asset.deliveryDate | localizedDate}}</div>
                        </div>
                    </div>
                    <hr class="divider">
                </div>
                <div class="asset-details">
                    <div class="text-container">
                        <div class="condition">{{'asset.productType' | translate }}:</div>
                        <div HJSuppress class="condition-value">
                            @switch (asset.dictionaryContractType.code) {
                                @case (ContractType.OPERATIONAL_LEASING) {
                                    {{'contracts.contractType.operationalLeasing' | translate}}
                                }
                                @case (ContractType.FINANCIAL_LEASING) {
                                    {{'contracts.contractType.financialLeasing' | translate}}
                                }
                                @case (ContractType.CREDIT) {
                                    {{'contracts.contractType.credit' | translate}}
                                }
                            }
                        </div>
                    </div>
                    <hr class="divider">
                </div>
                <div *ngIf="asset?.dictionaryAssetType" class="asset-details">
                    <dynamic-field [props]="props?.AssetType" [canBeEmpty]="true">
                        <div class="text-container">
                            <div class="condition">{{'asset.Type' | translate}}:</div>
                            <div HJSuppress class="condition-value">
                                <div >{{asset?.dictionaryAssetType.value}}</div>
                            </div>
                        </div>
                        <hr class="divider">
                    </dynamic-field>
                </div>
                <div class="asset-details">
                    <dynamic-field [props]="props?.Condition" [canBeEmpty]="true">
                        <div class="text-container">
                            <div class="condition">{{'asset.Condition' | translate}}:</div>
                            <div HJSuppress class="condition-value">
                                <div>{{asset?.condition ?
                                    ('asset.conditionSh'| translate) :
                                    ('asset.conditionNew'| translate)}}
                                </div>

                            </div>
                        </div>
                        <hr class="divider">
                    </dynamic-field>
                </div>
                <div *ngIf="asset?.supplier" class="asset-details">
                    <dynamic-field [props]="props?.Supplier" [canBeEmpty]="true">
                        <div class="text-container">
                            <div class="condition">{{'asset.Supplier' | translate}}:</div>
                            <div HJSuppress class="condition-value">
                                <div>{{asset?.supplier | replaceIfNull}}</div>
                            </div>
                        </div>
                        <hr class="divider">
                    </dynamic-field>
                </div>
                <div *ngIf="asset?.manufactureYear" class="asset-details">
                    <dynamic-field [props]="props?.ManufactureYear" [canBeEmpty]="true">
                        <div class="text-container">
                            <div class="condition">{{'asset.ManufactureYear' | translate}}:</div>
                            <div HJSuppress class="condition-value">
                                <div>{{asset?.manufactureYear | replaceIfNull}}</div>
                            </div>
                        </div>
                        <hr class="divider">
                    </dynamic-field>
                </div>

                <span *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED || !asset.deliveryStatus" class="align-self-center mt-3" [ngbTooltip]="requestAccessWarnings.length > 0 ? warningMessagesTemplate : null" tooltipClass="request-warning-tooltip opacity-100">
                    <button *ngIf="activeContracts && asset.dictionaryContractType.code !== ContractType.CREDIT"
                        class="btn outline-btn"
                        (click)="redirectDocumentRequest($event, asset.contractExternalEntityId, asset.assetId)" [disabled]="requestAccessWarnings.length > 0">
                        {{'contractDetail.assets.documentRequest' | translate}}
                    </button>
                </span>

                <div class="row" *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED && (asset.lastInspectionDate || asset.nextInspectionDate)">
                    <div *ngIf="asset.lastInspectionDate">
                        <span class="inspection-label">{{ 'asset.lastInspection' | translate }}:&nbsp;</span>
                        <span HJSuppress class="inspection-label fw-bold">{{ asset.lastInspectionDate | localizedDate }}</span>
                    </div>
                    <div *ngIf="asset.nextInspectionDate">
                        <span class="inspection-label">{{ 'asset.nextInspection' | translate }}:&nbsp;</span>
                        <span HJSuppress class="inspection-label fw-bold">{{ asset.nextInspectionDate | localizedDate }}</span>
                    </div>
                    <div *ngIf="asset.nextInspectionDate">
                        <span class="inspection-label mobile-label">{{ 'asset.inspectionLink' | translate }}&nbsp;</span>
                        <span
                            class="inspection-label text-primary mobile-app-link"
                            (click)="openAssetInspectionModal($event)"
                        >{{ 'asset.mobileApp' | translate }}</span>
                        <span class="inspection-label mobile-label">{{ '.' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #warningMessagesTemplate>
    <ul class="text-start ps-4 m-0">
        <li *ngFor="let message of requestAccessWarnings" [innerHtml]="message | translate"></li>
    </ul>
</ng-template>
